import React from 'react';
import TransactionsUserManagement from "../user/TransactionsUserManagement";

const TransactionUserTab = () => {
    return (
        <>
            <TransactionsUserManagement />
        </>
    );
};

export default TransactionUserTab;
